module.exports = __webpack_public_path__ + "img/golden.00fd8be4.svg";